// Basic
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';

// Modules
import { MaterialModule } from '@app/material.module';

// Components
import { PaymentSubscriptionComponent } from './payment-subscription.component';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MaterialModule
  ],
  declarations: [PaymentSubscriptionComponent],
  exports: [PaymentSubscriptionComponent],
  entryComponents: [PaymentSubscriptionComponent]
})

export class PaymentSubscriptionModule { }
